import React, { useEffect } from 'react';

import { PageLayout } from '@/components/templates/PageLayout';
import { CmLongLoading, CmScrollBox } from '@/components/uiParts';
import { SearchItemSelectModal } from '@/pages/menu-managements/components/SearchItemSelectModal';
import { MenuManagementNewButtonArea } from '@/pages/menu-managements/components/TopButtonArea';
import { MenuManagementOptionGroupsForm } from '@/pages/menu-managements/option-groups/components/Form';
import { useMenuManagementOptionGroupForm } from '@/pages/menu-managements/option-groups/hooks/useMenuManagementOptionGroupForm';
import { routes } from '@/router';

const MenuManagementOptionGroupsNewPage: React.FC = (): JSX.Element => {
  const {
    associateBrandSelectInput,
    titleJa,
    memo,
    takeout,
    eatIn,
    delivery,
    error,
    searchItems,
    selectedItems,
    searchItemName,
    isSearching,
    quantity,
    targetsHeight,
    isLoading,
    isOptionGroupItemModalOpen,
    handleCreate,
    handleInputTitleJa,
    handleInputMemo,
    handleInputTakeoutPosCode,
    handleInputEatInPosCode,
    handleInputDeliveryPosCode,
    handleOnDragEnd,
    handleSearchItemNameInput,
    handleAddSelectItems,
    handleDeleteDragItem,
    handleInputQuantityMin,
    handleInputQuantityMax,
    handleInputQuantityMaxSameOption,
    initializeNewPageState,
    handleClickMultipleItemSelect,
    handleCloseOptionGroupItemModal,
    handleSetMultipleItems,
  } = useMenuManagementOptionGroupForm();

  useEffect(() => {
    (async () => {
      await initializeNewPageState();
    })();
  }, []);

  const isDisabledSubmitButton = [
    !error.titleJa.isTouched || error.titleJa.isError,
    error.memo.isError,
    error.quantity.min.isError,
    error.quantity.max.isError,
    error.quantity.maxSameOption.isError,
  ].some((error) => error);

  return (
    <PageLayout
      title={routes.menuManagementOptionGroupsNew.title}
      {...{ associateBrandSelectInput }}
    >
      <MenuManagementNewButtonArea
        listUrl="/menu-managements/option-groups"
        {...{ handleCreate, isDisabledSubmitButton }}
      />
      <CmScrollBox height={`calc(100vh - ${targetsHeight}px)`}>
        <MenuManagementOptionGroupsForm
          handleClickMultipleSelect={handleClickMultipleItemSelect}
          {...{
            associateBrandSelectInput,
            titleJa,
            memo,
            takeout,
            eatIn,
            delivery,
            handleInputTitleJa,
            handleInputMemo,
            handleInputTakeoutPosCode,
            handleInputEatInPosCode,
            handleInputDeliveryPosCode,
            error,
            searchItems,
            selectedItems,
            searchItemName,
            quantity,
            handleOnDragEnd,
            handleSearchItemNameInput,
            handleAddSelectItems,
            handleDeleteDragItem,
            isSearching,
            handleInputQuantityMin,
            handleInputQuantityMax,
            handleInputQuantityMaxSameOption,
          }}
          brandSelectValue={associateBrandSelectInput.value?.value ?? ''}
        />
      </CmScrollBox>
      {isLoading && <CmLongLoading />}
      <SearchItemSelectModal
        title="オプション商品の選択"
        emptyMessage="選択できるオプション商品がありませんでした"
        isLoading={isSearching}
        isOpen={isOptionGroupItemModalOpen}
        onClose={handleCloseOptionGroupItemModal}
        selectedItems={selectedItems}
        searchItems={searchItems}
        handleSetMultipleItems={handleSetMultipleItems}
      />
    </PageLayout>
  );
};

export default MenuManagementOptionGroupsNewPage;
